import { Checkbox as ShadcnCheckbox } from '@shadcn/components/ui/checkbox';
import { useId } from 'react';

type Props = React.ComponentProps<typeof ShadcnCheckbox> & {
  label: string;
};
export const Checkbox = ({ label, ...props }: Props) => {
  const defaultId = useId();
  const id = props.id || defaultId;
  return (
    <>
      <ShadcnCheckbox id={id} className="cursor-pointer" {...props} />
      <label className="Label text-sm text-gray-700" htmlFor={id}>
        {label}
      </label>
    </>
  );
};
